<!-- Keymap Style Form -->
@if (keymapStyleForm) {
  <medsurf-design-form-control-form
    [formGroup]="keymapStyleForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-1 flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.spacing">
      </h4>
      <!-- Column Distance -->
      <medsurf-design-form-control-input-number [control]="keymapStyleForm.controls.columnDistance"
        [class]="'w-full'"
        [min]="0"
        [label]="'global.column_distance'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
      <!-- Row Distance -->
      <medsurf-design-form-control-input-number [control]="keymapStyleForm.controls.rowDistance"
        [class]="'w-full'"
        [min]="0"
        [label]="'global.row_distance'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
      <!-- Index Width -->
      <medsurf-design-form-control-input-number [control]="keymapStyleForm.controls.indexWidth"
        [class]="'w-full'"
        [min]="0"
        [label]="'global.index_distance'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
    </div>
  </medsurf-design-form-control-form>
}